// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__L1-YD","options":"AnswerScale_options__3rA0I","selected":"AnswerScale_selected__2Crm4"};